<template>
	<div class="entry">
		<div class="entry__side">
			<LoginForm />
		</div>
		<div class="entry__side">
			<RegisterForm />
		</div>
	</div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/components/entry';
</style>

<script>
export default {
	name: 'Entry',
	components: {
    'LoginForm': () => import('@/pages/components/includes/LoginForm'),
		'RegisterForm': () => import('@/pages/components/includes/RegisterForm'),
	}
}
</script>
